import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import Modal from 'react-modal';
import _ from 'lodash';
import * as SettingActions from './../../actions/settingScreen_actions';
import { validate } from '../../validations';
import { ModalDialogCommon } from './../modal_dialog_common';

let UpdateSecurityQuestions = React.createClass({
    getInitialState() {
        return {
            showPasswordModal: false,
            ErrorMsg: null,
            isoTPSubmitted: null,
            invalidPasswordErrorMsg: null,
            isVerifyPasswordSubmitted: false,
            isUpdateSecurityQuestionsSubmitted: null,
            oKModelMessage: null,
            isSubmitEnabled: null,
            isEditMode: null,
            invalidOTPErrorMsg: null
        }
    },
    componentWillReceiveProps(nextProps) {
        if (nextProps.otpResponseData && this.state.isOTPTriggered && this.state.isoTPSubmitted && nextProps.otpResponseData.status === 200) {

            var data = {
                "id": this.props.LoginDetails.data.id,
                "uniqueKey": this.props.LoginDetails.data.uniqueKey,
                "sequrityAnswer": [
                    {
                        "answer": this.refs.question1Answer.value.trim(),
                        "question": {
                            "id": this.refs.question1Id.value
                        }
                    },
                    {
                        "answer": this.refs.question2Answer.value.trim(),
                        "question": {
                            "id": this.refs.question2Id.value
                        }
                    },
                    {
                        "answer": this.refs.question3Answer.value.trim(),
                        "question": {
                            "id": this.refs.question3Id.value
                        }
                    },
                    // {
                    //     "answer": this.refs.question4Answer.value.trim(),
                    //     "question": {
                    //         "id": this.refs.question4Id.value
                    //     }
                    // },
                    // {
                    //     "answer": this.refs.question5Answer.value.trim(),
                    //     "question": {
                    //         "id": this.refs.question5Id.value
                    //     }
                    // },
                ]
            };

            this.props.Dispatch(SettingActions.updateSecrityQuestions(data));
            this.setState({ isUpdateSecurityQuestionsSubmitted: true });

        } else if (nextProps.otpResponseData && this.state.isOTPTriggered && nextProps.otpResponseData.status !== 200) {
            this.setState({ invalidOTPErrorMsg: nextProps.otpResponseData.message })
        }

        // Password Verification Response - As per BA current requirements password verification need to remove
        if (this.state.isVerifyPasswordSubmitted) {
            if (nextProps.VerifyPasswordResponse.status == 200) {
                nextProps.VerifyPasswordResponse.status = "";
                this.setState({
                    showPasswordModal: false
                })

                var data = {
                    "id": this.props.LoginDetails.data.id,
                    "uniqueKey": this.props.LoginDetails.data.uniqueKey,
                    "sequrityAnswer": [
                        {
                            "answer": this.refs.question1Answer.value.trim(),
                            "question": {
                                "id": this.refs.question1Id.value
                            }
                        },
                        {
                            "answer": this.refs.question2Answer.value.trim(),
                            "question": {
                                "id": this.refs.question2Id.value
                            }
                        },
                        {
                            "answer": this.refs.question3Answer.value.trim(),
                            "question": {
                                "id": this.refs.question3Id.value
                            }
                        },
                        // {
                        //     "answer": this.refs.question4Answer.value.trim(),
                        //     "question": {
                        //         "id": this.refs.question4Id.value
                        //     }
                        // },
                        // {
                        //     "answer": this.refs.question5Answer.value.trim(),
                        //     "question": {
                        //         "id": this.refs.question5Id.value
                        //     }
                        // },
                    ]
                };

                this.props.Dispatch(SettingActions.updateSecrityQuestions(data))
                this.setState({ isUpdateSecurityQuestionsSubmitted: true });

            } else {
                this.setState({
                    invalidPasswordErrorMsg: nextProps.VerifyPasswordResponse.message,
                })
            }

            this.setState({
                isVerifyPasswordSubmitted: null,
            });

        }

        // Update Security Questions Response
        if (this.state.isUpdateSecurityQuestionsSubmitted) {
            this.setState({ isSubmitEnabled: null });

            if (nextProps.Settings.updateUserSelectedSecurityQuestionsStatus && nextProps.Settings.updateUserSelectedSecurityQuestionsStatus.status == 200) {
                nextProps.Settings.updateUserSelectedSecurityQuestionsStatus.status = '';
                this.setState({ isEditMode: null });
                this.setState({ oKModelMessage: nextProps.Settings.updateUserSelectedSecurityQuestionsStatus.message })
            }

            if (nextProps.Settings.updateUserSelectedSecurityQuestionsStatus && nextProps.Settings.updateUserSelectedSecurityQuestionsStatus.status != 200) {
                this.setState({ oKModelMessage: nextProps.Settings.updateUserSelectedSecurityQuestionsStatus.message })
            }

            this.setState({ isUpdateSecurityQuestionsSubmitted: null, isoTPSubmitted: null, isOTPTriggered: false });
        }
    },
    componentWillMount() {
        this.props.Dispatch(SettingActions.getsecurityAnswers());
        this.props.Dispatch(SettingActions.getAllSecurityQuestions());
    },

    componentDidMount() {

    },

    verifyPassword() {
        if (this.refs.oldPassword.value != "") {
            var PassCheck = {
                "id": this.props.LoginDetails.data.id,
                "uniqueKey": this.props.LoginDetails.data.uniqueKey,
                "password": this.refs.oldPassword.value
            }
            this.setState({
                invalidPasswordErrorMsg: null,
                isVerifyPasswordSubmitted: true,
            });
            this.props.Dispatch(SettingActions.verifyPass(PassCheck));
        }
        else {
            this.setState({
                isVerifyPasswordSubmitted: null,
                invalidPasswordErrorMsg: 'Please enter valid password.',
            });
        }
    },

    removeCancelPrompt() {
        this.setState({
            showPasswordModal: false,
            invalidPasswordErrorMsg: null,
            isOTPTriggered: false
        });
    },


    removeInvalidPasswordErrorMsg() {
        this.setState({
            invalidPasswordErrorMsg: null
        })
    },

    update() {
        // To make the fields editable
        if (!this.state.isEditMode) {
            this.setState({ isEditMode: true });
            return;
        }
        if (this.state.isEditMode && !this.state.isSubmitEnabled) {
            this.setState({ oKModelMessage: "Please update any field to save." });
            return;
        }
        // Questions & Answers validations
        let isValidQ1 = validate.noSpaces(this.refs.question1Id);
        let isValidQ1Answer = validate.noSpaces(this.refs.question1Answer);
        isValidQ1 && isValidQ1Answer ? this.refs.question1Answer.className = 'update-mail' : this.refs.question1Answer.className = 'update-mail error-border-bottom';

        let isValidQ2 = validate.noSpaces(this.refs.question2Id);
        let isValidQ2Answer = validate.noSpaces(this.refs.question2Answer);
        isValidQ2 && isValidQ2Answer ? this.refs.question2Answer.className = 'update-mail' : this.refs.question2Answer.className = 'update-mail error-border-bottom';

        let isValidQ3 = validate.noSpaces(this.refs.question3Id);
        let isValidQ3Answer = validate.noSpaces(this.refs.question3Answer);
        isValidQ3 && isValidQ3Answer ? this.refs.question3Answer.className = 'update-mail' : this.refs.question3Answer.className = 'update-mail error-border-bottom';

        // let isValidQ4 = validate.noSpaces(this.refs.question4Id);
        // let isValidQ4Answer = validate.noSpaces(this.refs.question4Answer);
        // isValidQ4 && isValidQ4Answer ? this.refs.question4Answer.className = 'update-mail' : this.refs.question4Answer.className = 'update-mail error-border-bottom';

        // let isValidQ5 = validate.noSpaces(this.refs.question5Id);
        // let isValidQ5Answer = validate.noSpaces(this.refs.question5Answer);
        // isValidQ5 && isValidQ5Answer ? this.refs.question5Answer.className = 'update-mail' : this.refs.question5Answer.className = 'update-mail error-border-bottom';


        // if (isValidQ1 && isValidQ1Answer && isValidQ2 && isValidQ2Answer && isValidQ3 && isValidQ3Answer && isValidQ4 && isValidQ4Answer && isValidQ5 && isValidQ5Answer) {
        if (isValidQ1 && isValidQ1Answer && isValidQ2 && isValidQ2Answer && isValidQ3 && isValidQ3Answer) {

            // Unique Answer verification
            let hasRepeatedAnswers = null;
            for (let sq = 1; sq <= 3; sq++) {
                for (let i = 1; i <= 3; i++) {
                    if (sq != i) {
                        if (this.refs['question' + sq + 'Answer'].value.trim() === this.refs['question' + i + 'Answer'].value.trim()) {
                            this.refs['question' + sq + 'Answer'].className = 'update-mail error-border-bottom';
                            this.refs['question' + i + 'Answer'].className = 'update-mail error-border-bottom';
                            hasRepeatedAnswers = true;
                        }
                    }
                }
            }
            if (hasRepeatedAnswers) {
                this.setState({ ErrorMsg: 'Please enter a unique answer to each question.' });
                return;
            }


            this.setState({
                showPasswordModal: false, // true - to show password modal
                ErrorMsg: null,
            });
            this.props.Dispatch(SettingActions.getOTP({
                id: this.props.LoginDetails.data.id,
                email: this.props.LoginDetails.data.email,
                "uniqueKey": this.props.LoginDetails.data.uniqueKey,
                "deviceKey": this.props.LoginDetails.data.deviceKey
            }));
            this.setState({ isOTPTriggered: true });


        } else {
            this.setState({
                ErrorMsg: 'Please select and answer all the security questions to proceed.',
            })
        }
    },

    handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.verifyPassword();
        }
    },

    remove_error(event) {
        event.target.className = 'update-mail';
    },
    no_empty(event) {
        let value = event.target.value;
        let isEmptyValue = validate.notEmpty(value);
        isEmptyValue ? event.target.className = 'update-mail' : event.target.className = 'update-mail error-border-bottom';
    },

    selectionChanged(event) {
        // event.target.value != "" ? event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown' : event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom';
        this.setState({ isSubmitEnabled: true });
        this.setState({ isEditMode: true });
    },

    closebox() {
        this.setState({ oKModelMessage: null });
    },
    enableSubmit() {
        this.setState({ isSubmitEnabled: true });
        this.setState({ isEditMode: true });
    },
    togglePassword() {
        var pwd = document.getElementById("password");
        pwd.type === "password" ? pwd.type = "text" : pwd.type = "password";
    },
    render() {
        let sortAnswers = function (a, b) {
            return a.question.id - b.question.id;
        };
        let previousAnswers = [];
        if (this.props.previouslyUserSelectedSecurityQuestionsAndAnswers && this.props.previouslyUserSelectedSecurityQuestionsAndAnswers.length > 0) {
            previousAnswers = this.props.previouslyUserSelectedSecurityQuestionsAndAnswers.sort(sortAnswers);
        }

        var allSecurityQuestions = [];
        let sortAllQuestions = function (a, b) {
            return a.id - b.id;
        };
        if (this.props.Settings.allSecurityQuestions && this.props.Settings.allSecurityQuestions.data && this.props.Settings.allSecurityQuestions.data.length > 0) {
            allSecurityQuestions = this.props.Settings.allSecurityQuestions.data.sort(sortAllQuestions);
        }

        var option1 = [], option2 = [], option3 = [], option4 = [], option5 = [];
        _.forEach(allSecurityQuestions, function (value, key) {
            if (key < 5) {
                option1.push(allSecurityQuestions[key])
            }
            if (key >= 5 && key < 10) {
                option2.push(allSecurityQuestions[key])
            }
            if (key >= 10 && key < 15) {
                option3.push(allSecurityQuestions[key])
            }
            if (key >= 15 && key < 20) {
                option4.push(allSecurityQuestions[key])
            }
            if (key >= 20 && key < 25) {
                option5.push(allSecurityQuestions[key])
            }
        });

        return (

            <div role="tabpanel" className="tab-pane active" id="weekly">
                <div className="settings_questions">
                    <div className="row">
                        <div className="col-xs-10 no-padding">
                            <div className="btn-group">
                                <div className="dropdown">
                                    <div className="source">
                                        <div className="question-selection" >
                                            <select ref="question1Id" defaultValue={previousAnswers && previousAnswers[0] && previousAnswers[0].question ? previousAnswers[0].question.id : ''} onChange={this.selectionChanged}>
                                                <option value="" default>Please select</option>
                                                {
                                                    _.map(option1, (Data, key) => {

                                                        return (
                                                            <option key={key} value={Data.id}>
                                                                {Data.name}
                                                            </option>
                                                        );
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>

                                    <input className="update-mail" type="text" ref="question1Answer" key={previousAnswers ? "loaded" : "notLoaded"} defaultValue={previousAnswers && previousAnswers[0] && previousAnswers[0].question ? previousAnswers[0].answer : ''} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} />

                                    <div className="source">
                                        <div className="question-selection" >
                                            <select ref="question2Id" defaultValue={previousAnswers && previousAnswers[1] && previousAnswers[1].question ? previousAnswers[1].question.id : ''} onChange={this.selectionChanged}>
                                                <option value="" default>Please select</option>
                                                {
                                                    _.map(option2, (Data, key) => {
                                                        return (
                                                            <option key={key} value={Data.id}>
                                                                {Data.name}
                                                            </option>
                                                        );
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <input className="update-mail" type="text" ref="question2Answer" defaultValue={previousAnswers && previousAnswers[1] && previousAnswers[1].question ? previousAnswers[1].answer : ''} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} />
                                    <div className="source">
                                        <div className="question-selection" >
                                            <select ref="question3Id" defaultValue={previousAnswers && previousAnswers[2] && previousAnswers[2].question ? previousAnswers[2].question.id : ''} onChange={this.selectionChanged}>
                                                <option value="" default>Please select</option>
                                                {
                                                    _.map(option3, (Data, key) => {
                                                        return (
                                                            <option key={key} value={Data.id}>
                                                                {Data.name}
                                                            </option>
                                                        );
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>

                                    <input className="update-mail" type="text" ref="question3Answer" defaultValue={previousAnswers && previousAnswers[2] && previousAnswers[2].question ? previousAnswers[2].answer : ''} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} />
                                    {/* <div className="source">
                                        <div className="question-selection" >
                                            <select ref="question4Id" defaultValue={previousAnswers && previousAnswers[3] && previousAnswers[3].question ? previousAnswers[3].question.id : ''} onChange={this.selectionChanged}>
                                                <option value="" default>Please select</option>
                                                {
                                                    _.map(option4, (Data, key) => {
                                                        return (
                                                            <option key={key} value={Data.id}>
                                                                {Data.name}
                                                            </option>
                                                        );
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <input className="update-mail" type="text" ref="question4Answer" defaultValue={previousAnswers && previousAnswers[3] && previousAnswers[3].question ? previousAnswers[3].answer : ''} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} /> */}
                                    {/* <div className="source">
                                        <div className="question-selection" >
                                            <select ref="question5Id" defaultValue={previousAnswers && previousAnswers[4] && previousAnswers[4].question ? previousAnswers[4].question.id : ''} onChange={this.selectionChanged}>
                                                <option value="" default>Please select</option>
                                                {
                                                    _.map(option5, (Data, key) => {
                                                        return (
                                                            <option key={key} value={Data.id}>
                                                                {Data.name}
                                                            </option>
                                                        );
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <input className="update-mail" type="text" ref="question5Answer" defaultValue={previousAnswers && previousAnswers[4] && previousAnswers[4].question ? previousAnswers[4].answer : ''} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.ErrorMsg && <span className="red-color">{this.state.ErrorMsg}</span>}
                </div>

                <button className="gray-button update" onClick={this.update}>{this.state.isEditMode ? "Update" : "EDIT"}</button>

                {this.state.oKModelMessage && <ModalDialogCommon message={this.state.oKModelMessage} action={this.closebox} />}
                <Modal isOpen={this.state.showPasswordModal} className='delete-prompt modalPopup logout' contentLabel='modalPopup'>
                    <div className="popup-content profile text-center">
                        <p className='main_header'>
                            Please enter your password to proceed.
                         </p>
                        <div>
                            <div className="input-group">
                                <div className="input-group">
                                    <input type="password" ref="oldPassword" className="inputText" id="password" onChange={this.removeInvalidPasswordErrorMsg} onKeyPress={this.handleKeyPress} required />
                                    <span className="floating-label">PASSWORD</span>
                                    <img src={require('./../../images/eye-open.png')} className='eye-icon' onClick={() => { this.togglePassword() }} />
                                </div>
                                {this.state.invalidPasswordErrorMsg &&
                                    <div className="error-message">
                                        <span className="red-color">{this.state.invalidPasswordErrorMsg} </span>
                                    </div>}
                            </div>
                            <input type='button' value='SUBMIT' className='button button-primary btn-submit gray-button' ref='deleteBtn' onClick={this.verifyPassword} />
                            <input type='button' value='CANCEL' className='button button-primary btn-submit white-button' ref='deleteCancelBtn' onClick={this.removeCancelPrompt} />
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.isOTPTriggered} className='delete-prompt modalPopup logout' contentLabel='modalPopup'>
                    <div className="popup-content profile text-center">
                        <p className='main_header'>
                            {/* We just sent you an XXXX digit code to {this.props.LoginDetails.data.email}.
                            Please enter the code below. */}
                            We just sent you an XXXX digit code to your registered Email ID. Please enter the code below.
                                </p>
                        <div>
                            <div className="input-group">
                                <input type='text' ref='otp' className="inputText" onKeyPress={this.handleKeyPress} required maxLength={4} />
                                <span className="floating-label">OTP</span>
                                {this.state.invalidOTPErrorMsg &&
                                    <div className="error-message">
                                        <span className="red-color">{this.state.invalidOTPErrorMsg} </span>
                                    </div>}
                            </div>
                            <input type='button' value='SUBMIT' className='button button-primary btn-submit gray-button' ref='deleteBtn' onClick={() => {
                                this.props.Dispatch(SettingActions.verifyOTP({
                                    "otp": this.refs.otp.value,
                                    "id": this.props.LoginDetails.data.id,
                                    "deviceKey": this.props.LoginDetails.data.deviceKey
                                }));
                                this.setState({ isoTPSubmitted: true });
                            }} />
                            <input type='button' value='CANCEL' className='button button-primary btn-submit white-button' ref='deleteCancelBtn' onClick={this.removeCancelPrompt} />
                        </div>
                    </div>
                </Modal>
            </div>

        );
    }
});

let mapStateToProps = (state) => {
    return {
        previouslyUserSelectedSecurityQuestionsAndAnswers: state.Setting.SecurityAnswers,
        LoginDetails: state.User.loginData,
        VerifyPasswordResponse: state.Setting.verification,
        Settings: state.Setting,
        otpResponseData: state.User.OTPResponse

    };
};

let mapDispatchToProps = (dispatch) => ({
    SettingActions: bindActionCreators(SettingActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(UpdateSecurityQuestions));



/** WEBPACK FOOTER **
 ** ./src/components/settingsScreen/updateSecurityQuestions.js
 **/